import React from 'react';
import { Box, LoadingOverlay } from '@mantine/core';
import { ProductPreview } from './productPreview/ProductPreview';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { Aside } from './aside/Aside';
import { CreatorHelpDrawer } from './partials/creatorHelpDrawer/CreatorHelpDrawer';
import { ProjectRenderer } from '@/renderer/ProjectRenderer';
import APP_CONFIG from '@/configs/appConfig';

const renderer = ProjectRenderer.getInstance();

export const Creator: React.FC = () => {
	const dispatch = useTypedDispatch();

	const isLoading = useTypedSelector((state) => state.app.loading);
	const { options } = useTypedSelector((app) => app.creator);

	const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
		e.preventDefault();

		// const serializedRenderer = renderer.export();
	};

	return (
		<Box className="creator-wrapper" component="form" onSubmit={handleSubmit}>
			<LoadingOverlay
				visible={isLoading}
				zIndex={APP_CONFIG.Z_INDEX.CREATOR_LOADING}
			/>
			<ProductPreview />
			<Aside />
			<CreatorHelpDrawer />
		</Box>
	);
};
